import React, { Dispatch, SetStateAction } from "react"
import { cl } from "../../helpers/general"
import { GRADIENT_1 } from "../../styles"
import { useStaticQuery, graphql } from "gatsby";

interface Props {
  className?: string;
  onClick: Dispatch<SetStateAction<boolean>>
}

export const DownloadAppButton = (props: Props) => {
  const rawData = useStaticQuery(graphql`
    query {
      sanityBasicSettings {
        headerCTA {
          url
          label
        }
      }
    }
  `);

  const data = rawData.sanityBasicSettings;

  return <button
    type="button"
    className={cl(
      "rounded-full overflow-hidden p-[1px]",
      props.className,
      GRADIENT_1
    )}
    onClick={() => {
      if (data.headerCTA.url) {
        location.href = "https://wa.me/919744062997"
      } else {
        props.onClick(true)
      }
    }}
  >
    <div className="rounded-full bg-black text-white">
      <div
        className={cl(
          "text-transparent bg-clip-text px-6 py-2 whitespace-nowrap",
          GRADIENT_1
        )}
      >
        {data.headerCTA.label}
      </div>
    </div>
  </button>
}
